import React from "react";

export function AppFooter() {

    return <div className="footer1">
        <div className="container">

            <div className="one_fourth">

                <ul className="faddress">
                    <li><img src="../src/assets/images/footer-logo.png" alt=""/></li>

                    <li><a href="mailto:podrska@sistemx.ba"><i className="fa fa-envelope"></i> podrska@sistemx.ba</a>
                    </li>
                </ul>

            </div>


            <div className="one_fourth">
                <div className="qlinks">


                    <h3 className="lmb nocaps">Linkovi</h3>

                    <ul>
                        <li><a href="https://www.sistemx.ba"><i className="fa fa-angle-right"></i>Naslovnica</a></li>
                        <li><a href="xpay_index.html#/main/login"><i className="fa fa-angle-right"></i>Upravljanje
                            računom</a>
                        </li>
                        <li><a href="https://www.sistemx.ba/kontakt"><i className="fa fa-angle-right"></i> Kontakt</a>
                        </li>
                    </ul>

                </div>
            </div>


            <div className="one_fourth">
                <div className="frposts">

                    <h3 className="lmb nocaps">Servisi</h3>

                    <ul>
                        <li><a href="xpay_index.html#/main/login"><i className="fa fa-caret-right"></i> xPay - Moj Račun</a>
                        </li>
                        <li><a href="xkvik_index.html#/kvik"><i className="fa fa-caret-right"></i> KviKlik - Dopuni
                            klikom!</a>
                        </li>
                        <li><a href="https://www.sistemx.ba/xspot-prodajna-mjesta"><i className="fa fa-caret-right"></i>
                            xSpot - Prodajna Mjesta</a></li>

                    </ul>

                </div>
            </div>


            <div className="one_fourth last">

            </div>

        </div>
    </div>


}